import { PdfFittingFormType } from '../enums/pdf-fitting-form-type.enum';

export class PdfFittingFormTypeHelper {
  private static readonly LABELS: Record<PdfFittingFormType, string> = {
    [PdfFittingFormType.FittingFormWithParams]: "Bon d'essayage",
    [PdfFittingFormType.FittingForm]: "Bon d'essayage",
    [PdfFittingFormType.FittingFormLabelTag89x28]: "Etiquette d'essayage (89x28mm)",
    [PdfFittingFormType.FittingFormLabelTag23x23]: "Etiquette d'essayage (23x23mm)",
    [PdfFittingFormType.FittingFormWithAmount]: "Bon d'essayage avec montants",
    [PdfFittingFormType.FittingFormWithoutAmount]: "Bon d'essayage sans montant",
    [PdfFittingFormType.FittingFormWithAndWithoutAmount]: "Bon d'essayage avec et sans montants",
  };

  private static readonly LABELS_PLURAL: Record<PdfFittingFormType, string> = {
    [PdfFittingFormType.FittingFormWithParams]: "Bons d'essayage",
    [PdfFittingFormType.FittingForm]: "Bons d'essayage",
    [PdfFittingFormType.FittingFormLabelTag89x28]: "Etiquettes d'essayage (89x28mm)",
    [PdfFittingFormType.FittingFormLabelTag23x23]: "Etiquettes d'essayage (23x23mm)",
    [PdfFittingFormType.FittingFormWithAmount]: "Bons d'essayage avec montants",
    [PdfFittingFormType.FittingFormWithoutAmount]: "Bons d'essayage sans montant",
    [PdfFittingFormType.FittingFormWithAndWithoutAmount]: "Bons d'essayage avec et sans montants",
  };

  public static buildPdfMergeNotificationCardMessage(length: number, pdfDocumentType: PdfFittingFormType): string | undefined {
    let msg: { msgPlural: string | undefined; msgSingular: string | undefined } = { msgPlural: undefined, msgSingular: undefined };

    if (pdfDocumentType === PdfFittingFormType.FittingForm || pdfDocumentType === PdfFittingFormType.FittingFormWithParams) {
      msg = {
        msgPlural: `PDF de ${length} bons d'essayage`,
        msgSingular: `PDF de ${length} bon d'essayage`,
      };
    } else if (pdfDocumentType === PdfFittingFormType.FittingFormLabelTag89x28) {
      msg = {
        msgPlural: `PDF de ${length} étiquettes d'essayage`,
        msgSingular: `PDF de ${length} étiquette d'essayage`,
      };
    } else if (pdfDocumentType === PdfFittingFormType.FittingFormLabelTag23x23) {
      msg = {
        msgPlural: `PDF de ${length} étiquettes d'essayage`,
        msgSingular: `PDF de ${length} étiquette d'essayage`,
      };
    } else if (pdfDocumentType === PdfFittingFormType.FittingFormWithAmount) {
      msg = {
        msgPlural: `PDF de ${length} bons d'essayage avec montants`,
        msgSingular: `PDF de ${length} bon d'essayage avec montants`,
      };
    } else if (pdfDocumentType === PdfFittingFormType.FittingFormWithoutAmount) {
      msg = {
        msgPlural: `PDF de ${length} bons d'essayage sans montant`,
        msgSingular: `PDF de ${length} bon d'essayage sans montant`,
      };
    } else if (pdfDocumentType === PdfFittingFormType.FittingFormWithAndWithoutAmount) {
      msg = {
        msgPlural: `PDF de ${length} bons d'essayage avec et sans montants`,
        msgSingular: `PDF de ${length} bon d'essayage avec et sans montants`,
      };
    }

    const message = length > 1 ? msg.msgPlural : msg.msgSingular;
    return message;
  }

  public static buildPdfMergeNotifyMessage(length: number, pdfDocumentType: PdfFittingFormType): string | undefined {
    let msg: { msgPlural: string | undefined; msgSingular: string | undefined } = { msgPlural: undefined, msgSingular: undefined };

    if (pdfDocumentType === PdfFittingFormType.FittingFormWithParams) {
      msg = {
        msgPlural: `PDF multiple de ${length} bons d'essayage en cours de génération`,
        msgSingular: `PDF multiple de ${length} bon d'essayage en cours de génération`,
      };
    } else if (pdfDocumentType === PdfFittingFormType.FittingForm) {
      msg = {
        msgPlural: `PDF multiple de ${length} bons d'essayage en cours de génération`,
        msgSingular: `PDF multiple de ${length} bon d'essayage en cours de génération`,
      };
    } else if (pdfDocumentType === PdfFittingFormType.FittingFormLabelTag89x28) {
      msg = {
        msgPlural: `PDF multiple de ${length} étiquettes d'essayage en cours de génération`,
        msgSingular: `PDF multiple de ${length} étiquette d'essayage en cours de génération`,
      };
    } else if (pdfDocumentType === PdfFittingFormType.FittingFormLabelTag23x23) {
      msg = {
        msgPlural: `PDF multiple de ${length} étiquettes d'essayage en cours de génération`,
        msgSingular: `PDF multiple de ${length} étiquette d'essayage en cours de génération`,
      };
    } else if (pdfDocumentType === PdfFittingFormType.FittingFormWithAmount) {
      msg = {
        msgPlural: `PDF multiple de ${length} bons d'essayage avec montants en cours de génération`,
        msgSingular: `PDF multiple de ${length} bon d'essayage avec montants en cours de génération`,
      };
    } else if (pdfDocumentType === PdfFittingFormType.FittingFormWithoutAmount) {
      msg = {
        msgPlural: `PDF multiple de ${length} bons d'essayage sans montant en cours de génération`,
        msgSingular: `PDF multiple de ${length} bon d'essayage sans montant en cours de génération`,
      };
    } else if (pdfDocumentType === PdfFittingFormType.FittingFormWithAndWithoutAmount) {
      msg = {
        msgPlural: `PDF multiple de ${length} bons d'essayage avec et sans montants en cours de génération`,
        msgSingular: `PDF multiple de ${length} bon d'essayage avec et sans montants en cours de génération`,
      };
    }

    const message = length > 1 ? msg.msgPlural : msg.msgSingular;
    return message;
  }

  public static translateEnum(enumValue: PdfFittingFormType, pluralFlag = false): string | undefined {
    return (pluralFlag ? this.LABELS_PLURAL : this.LABELS)[enumValue] ?? undefined;
  }
}
